import React from 'react';
import {
    IonModal,
    IonContent,
    IonButton,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonIcon,
    IonFooter, useIonAlert
} from '@ionic/react';
import {
    arrowBack,
} from 'ionicons/icons';
import AssignmentDetail from "./AssignmentDetail";
import useStore from "../zustand/useStore";
import {
    actionToApplyForAssignmentPortalPost,
} from "../apiHelpers/CommonAction";

export default function AssignmentsDetailSheetPopup({ isOpen, onDidDismiss,assignmentDetail,isMobile  }) {
    const {userAuthDetail} = useStore();
    const {userInfo} = userAuthDetail;
    const [presentAlert] = useIonAlert();

    const openRfpMailClient = async (rfpData) => {
        let interestedMembers = [];
        if (rfpData?.applied_member_id_array) {
            interestedMembers = JSON.parse(rfpData.applied_member_id_array);
        }

        if (!interestedMembers?.includes(userInfo?.id)) {
            interestedMembers.push(userInfo?.id);

            let template = await actionToApplyForAssignmentPortalPost(
                rfpData?.id,
                JSON.stringify(interestedMembers)
            );

            const subject = encodeURIComponent("RFP Assignment - Interested Candidate");
            let body = encodeURIComponent(
                "Hello,\n\nI am interested in this RFP assignment.\n\nThanks."
            );

            if (template) {
                let filledTemplate = template
                    .replace(/{ASSIGNMENT_TITLE}/g, rfpData?.title || "")
                    .replace(/{NAME}/g, userInfo?.name || "")
                    .replace(/{MOBILE}/g, userInfo?.phone_number || "")
                    .replace(/{EMAIL}/g, userInfo?.email || "");

                body = encodeURIComponent(filledTemplate);
            }

            window.location.href = `mailto:${rfpData?.apply_email}?subject=${subject}&body=${body}`;
        }
    };

    const applyForAssignment = (data)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to apply for this assignment.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Apply', role: 'confirm', handler: () =>openRfpMailClient(data)},
            ],
        });
    }


    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
            data-publisher-content="true"
        >
            {(assignmentDetail?.id) ?
                <>
                    <IonHeader className="job_detail_sheet_header sheet_modal_header">
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonButton className={"close_job_post_button"} onClick={onDidDismiss}>
                                    <IonIcon icon={arrowBack}/>
                                </IonButton>
                            </IonButtons>
                            <div className="job_detail_sheet_header_text">
                                <div className="job-basic-info-image">
                                    <span className="job-basic-info-text">{assignmentDetail.title}</span>
                                </div>
                            </div>
                            <IonButtons slot="end">
                                {(assignmentDetail?.created_by === userInfo?.id || userInfo?.role === 1) ?
                                    <></>
                                    :
                                    <>
                                        {(assignmentDetail?.applied_member_id_array && JSON.parse(assignmentDetail?.applied_member_id_array).includes(userInfo?.id)) ?
                                            <div className="in_card_action_button_edit_del">
                                                Contacted
                                            </div>
                                            :
                                            <div onClick={() => applyForAssignment(assignmentDetail)} className="in_card_action_button_edit_del">
                                                Contact
                                            </div>

                                        }
                                    </>
                                }
                            </IonButtons>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent className="ion-padding job_detail_sheet_content">
                        <AssignmentDetail assignmentDetail={assignmentDetail}/>
                    </IonContent>
                    {(isMobile) && (
                        <IonFooter className="blank_footer_bar">
                            <IonToolbar>
                                <div id={'web-ad-banner-bottom'} className={"add_in_main_news_page_appear_here"}>
                                    <div>
                                        Google ads will appear here
                                    </div>
                                </div>
                            </IonToolbar>
                        </IonFooter>
                    )}
                </>:''
            }
        </IonModal>
    );
}
